import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const JobseekerBlog = () => {
  const [banner, setBanner] = useState(null);
  const [blogs, setBlogs] = useState([]);

  // Fetch banner
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/banners/job-seekers-blog-or-resources"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.banners && data.banners.length > 0) {
          setBanner(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner:", err));
  }, []);

  // Fetch blogs
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/content/job-seekers-blog-or-resources"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.content) {
          setBlogs(data.content);
        }
      })
      .catch((err) => console.error("Error fetching blogs:", err));
  }, []);

  return (
    <>
      {/* Banner Section */}
      {banner && (
        <section
          className="jobseeker-blog jobseeker-blog-mobile"
          style={{
            backgroundImage: `url(/prosapiens-cms/public/${banner.banner_image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="overlay container">
            <div className="hero-text">
              <h1>{banner.banner_title}</h1>
              <div
                style={{ color: "#fff" }}
                dangerouslySetInnerHTML={{ __html: banner.content_text }}
              />
            </div>
          </div>
        </section>
      )}

      {/* Blogs Section */}
      <div className="container">
        <div className="blog-grid">
          {blogs.map((blog) => (
            <div className="blog-card" key={blog.id}>
              <Link to={`/blogs/${blog.id}`}>
                <div className="blog-content">
                  <div
                    className="blog-excerpt"
                    dangerouslySetInnerHTML={{ __html: blog.content_text }}
                  />
                  {blog.content_image && (
                    <div className="blog-image">
                      <img
                        src={`/prosapiens-cms/public/${blog.content_image}`}
                        alt={blog.content_title}
                      />
                    </div>
                  )}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default JobseekerBlog;
